import React, {useLayoutEffect, useState} from 'react'
import HighchartsReact from 'highcharts-react-official'
import HC from 'highcharts/highcharts-more';
import {Divider, Grid, Paper, Tooltip} from "@material-ui/core";
import {Error} from "@material-ui/icons";
import {getChartOptions} from "./utils";
import {styles} from "./styles";
import {makeStyles} from '@material-ui/styles';
import ChartLegend from './ChartLegend';
import Highcharts from 'highcharts';
import localforage from "../../utils/localforage";


const useStyles = makeStyles(styles);


const Velocimetro = (props) => {
    const {options} = props

    const [optionsChart, setOptionsChart] = useState(getChartOptions(props.options));
    const [liderado, setLiderado] = useState('');

    useLayoutEffect(() => {
        if(JSON.stringify(optionsChart) !== JSON.stringify(getChartOptions(options))){
            setOptionsChart(getChartOptions(options))
        }

        localforage.getItem('liderado').then(ld => {
            if(ld && ld.nomeLiderado){
                setLiderado(ld.nomeLiderado);
            } 
        });
    }, [props])

    const classes = useStyles()
    const totalGeral = options.data.horasSemPlPt + options.data.horasPl + options.data.horasPt
    const horasExc = options.projecao.projecaoHorasExcMes;
    HC(Highcharts);
    return <Grid container direction={'column'} justifyContent={"center"} className={classes.velocimetro} wrap={"nowrap"}>
        <Paper className={classes.velocimetroPaper}>
            <div style={{textAlign: 'center', fontSize: '20px'}}>
                   {liderado}
            </div>
            <HighchartsReact
                immutable
                highcharts={Highcharts}
                options={optionsChart}
            />
            <Grid container direction={'row'} justifyContent={"center"} className={classes.legends}>
                <Grid container direction={'column'} justifyContent={"space-between"}>
                    <Grid container direction={'row'} justifyContent={"space-between"}>
                        <ChartLegend content={options.data.horasSemPlPt + options.data.horasFerias}
                                     color={'black'}
                                     label={`Trabalhadas + Férias`}
                                     rightIcon={
                                         <Tooltip title={'Horas do Project + Férias - (Plantão + Plantão Trabalhado)'}>
                                             <Error/>
                                         </Tooltip>
                                     }/>
                        <ChartLegend content={options.data.horasUteisAtual} label={`Úteis até hoje`} color={'green'}/>
                        <ChartLegend content={options.horasLiberadas.horasUteis} label={`Úteis no período`}
                                     color={'yellow'}/>
                        <ChartLegend label={`Extras`} color={'red'}/>
                    </Grid>
                    <Divider orientation={"horizontal"} style={{margin: '5px 0'}}/>
                    <Grid container direction={'row'} justifyContent={"space-between"}>
                        <ChartLegend content={options.data.horasPl} label={`Plantão`}/>
                        <ChartLegend content={options.data.horasPt} label={`Plantão Trabalhado`}/>
                        <ChartLegend content={totalGeral} label={`Total Geral`}
                                     rightIcon={
                                         <Tooltip title={'Horas trabalhadas + Férias + Plantão + Plantão Trabalhado'}>
                                             <Error/>
                                         </Tooltip>
                                     }/>
                        <ChartLegend content={horasExc}
                                     label={`Horas Exc.(D-1)`}
                                     rightIcon={
                                         <Tooltip title={'Horas Excedentes refetrente ao mês corrente'}>
                                             <Error/>
                                         </Tooltip>
                                     }/>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    </Grid>
}

export default Velocimetro
